<template>
  <div id='chartdiv'></div>
</template>

<script>
  import utils from '@/assets/utils/index.js'
  export default {
    data () {
      return {
        map: null,
        dataprovider: null
      }
    },
    props: {
      geoType: {
        type: Number
      },
      changeGeoType: {
        type: Number,
        default: 2
      }
    },
    computed: {
      geos () {
        return this.$store.getters['order/geoItems']
      },
      selectedGeo () {
        let result = []
        let orderGeos = this.$store.state.order.OrderGeos
        for (let geo of orderGeos) {
          if (geo.GeoType === this.realgeoType) {
            result.push({
              id: 'US-' + geo.GeoKeyCode,
              showAsSelected: true
            })
          }
        }
        if (this.map && this.map.validateData) {
          this.map.dataProvider.areas = result
          // this.map.validateDate()
        }
        return result
      },
      realgeoType () {
        return this.$store.state.geo.geoTypes.State.Code
      }
    },
    watch: {
      geos () {
        if (this.$route.name === 'geo-state') {
          this.updateSelect()
        }
      }
    },
    methods: {
      getIsSelected (code) {
        let orderGeos = this.$store.state.order.OrderGeos
        for (let key of Object.keys(orderGeos)) {
          if (code === orderGeos[key].GeoKeyCode) {
            return true
          }
        }
        return false
      },
      updateSelect () {
        this.map.dataProvider.areas = this.selectedGeo
        this.map.validateData()
      },
      createMap () {
        if (this.geoType === this.realgeoType) {
          this.$store.dispatch('order/changeGeoType', this.geoType)
        }
        let that = this
        this.map = window.AmCharts.makeChart('chartdiv', {
          type: 'map',
          theme: 'light',
          panEventsEnabled: true,
          // 'backgroundColor': '#666666',
          // 'backgroundAlpha': 1,
          dataProvider: {
            map: 'usaLow',
            getAreasFromMap: true,
            areas: this.selectedGeo
          },
          areasSettings: {
            autoZoom: false,
            color: '#CDCDCD',
            colorSolid: '#5EB7DE',
            selectedColor: '#4A90E2',
            outlineColor: '#666666',
            rollOverColor: '#88CAE7',
            rollOverOutlineColor: '#FFFFFF',
            selectable: true
          },
          zoomControl: {
            panControlEnabled: false,
            zoomControlEnabled: true
          },
          imagesSettings: {
            labelPosition: 'middle',
            labelFontSize: 9
          },
          listeners: [ {
            event: 'clickMapObject',
            method: function (event) {
              // deselect the area by assigning all of the dataProvider as selected object
              that.map.selectedObject = that.map.dataProvider

              // toggle showAsSelected
              event.mapObject.showAsSelected = !event.mapObject.showAsSelected

              // bring it to an appropriate color
              that.map.returnInitialColor(event.mapObject)

              // let's build a list of currently selected states
              that.$store.commit('order/cleanGeo', that.realgeoType)
              for (let i in that.map.dataProvider.areas) {
                let area = that.map.dataProvider.areas[i]
                if (area.showAsSelected) {
                  that.$store.commit('order/addGeo', {
                    GeoKeyCode: area.id.slice(3),
                    GeoKeyDesc: area.title,
                    GeoType: that.realgeoType
                  })
                } else {
                  that.$store.commit('order/deleteGeo', area.id.slice(3))
                }
              }
            }
          } ],
          export: {

          }
        })

        // sometimes the map created before init event
        this.addStateLabel()
        this.map.addListener('init', function () {
          setTimeout(that.addStateLabel, 10)
          setTimeout(() => {
            that.map.invalidateSize()
          })
        })
      },
      addStateLabel () {
        // See detail: https://www.amcharts.com/kbase/display-state-abbreviations-as-labels-over-us-map/
        this.map.dataProvider.images = []
        for (let x in this.map.dataProvider.areas) {
          let area = this.map.dataProvider.areas[x]
          let image = new window.AmCharts.MapImage()
          image.latitude = this.map.getAreaCenterLatitude(area)
          image.longitude = this.map.getAreaCenterLongitude(area)
          image.label = area.id.substr(3)
          image.title = area.title
          image.linkToObject = area
          this.map.dataProvider.images.push(image)
        }
        this.map.validateData()
      }
    },
    mounted () {
      if (!window.AmCharts) {
        utils.loadCss('./static/amcharts/export.css')
        utils.loadJs('./static/amcharts/main.js', this.createMap)

        // other link that doesn't use
        // 'https://www.amcharts.com/lib/3/maps/js/usaLow.js'
        // 'https://www.amcharts.com/lib/3/plugins/export/export.min.js'
        // 'https://www.amcharts.com/lib/3/themes/light.js'
      } else {
        this.createMap()
      }
    }
  }
</script>

<style scoped lang='scss'>


  .header {
    display: flex;
    justify-content: space-between;
  }

  .box-t{
    border: 1px solid #ccc;
    border-radius: 8px;
    background-color: $color-background;
    padding: 16px;
    width: 100%;
    margin-bottom:16px;
    display: block;
  }

  #chartdiv {
    width: 100%;
    height: 480px;
  }
</style>
<style>
  .export-main{
    display:none !important;
  }
  .amcharts-pan-home{
    display:none;
  }
  a[title="Interactive JavaScript maps"]{
    display:none !important;
  }
  path[file='#CDCDCD'] {
    cursor: pointer !important;
  }
  path[file='#4A90E2'] {
    cursor: pointer !important;
  }
  path[file='#5EB7DE'] {
    cursor: pointer !important;
  }
  path[file='#88CAE7'] {
    cursor: pointer !important;
  }
  .amcharts-map-area {
    cursor: pointer !important;
  }
  /*g[transform='translate(10,10)'] {*/
    /*display: none;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/Components/geo/MStateMap.vue